import Toast from 'react-native-toast-message'
import { saveFile } from '../utils/FileManager';
import { saveFiles, saveFolder } from './library';
import { getCurrentOrgID } from '../data/organization';
import ErrorHandler from '../utils/ErrorHandler';
import { supabase } from '../data/client';

const getSongs = async () => {
    const orgID = await getCurrentOrgID(); 

    const {error, data} = await supabase.from('Songs').select(`*,
        chordFile:Files!public_Songs_chordFileID_fkey(*, name:filename), 
        lyricFile:Files!public_Songs_lyricFileID_fkey(*, name:filename), 
        selfHostedTrackFile:Files!public_Songs_selfHostedTrackFileID_fkey(*, name:filename), 
        Folder:Folders(*, subfolders:Folders(*), files:Files(*))
    `).eq('organizationID', orgID).order('name', {ascending: true});

    if(error){
        ErrorHandler(Error(error.message), {organizationID: orgID}, `Something went wrong getting songs for organization`)
        return [];
    }

    return data;
}

const getSong = async (id) => {
    const orgID = await getCurrentOrgID(); 

    const {error, data} = await supabase.from('Songs').select(`*,
        chordFile:Files!public_Songs_chordFileID_fkey(*, name:filename), 
        lyricFile:Files!public_Songs_lyricFileID_fkey(*, name:filename), 
        selfHostedTrackFile:Files!public_Songs_selfHostedTrackFileID_fkey(*, name:filename), 
        Folder:Folders(*, subfolders:Folders(*), files:Files(*))
    `).eq('organizationID', orgID).eq('id', id).maybeSingle();

    if(error){
        ErrorHandler(Error(error.message), {organizationID: orgID}, `Something went wrong getting that song`)
        return {};
    }

    return data;
}


const getSongsByEventInstance = async (eventInstanceID) => {
    if(!eventInstanceID){
        return [];
    }

    const {error, data} = await supabase.from('EventSongs').select('*, Song(*, Folder:Folders(*, subfolders:Folders(*), files:Files(*)))').eq('eventInstanceID', eventInstanceID);

    if(error){
        ErrorHandler(Error(error.message), {eventInstanceID}, `Something went wrong getting songs for event instance`)
        return [];
    }

    return data;
}



const saveSong = async ({details, createdByID}) => {
    const orgID = await getCurrentOrgID();
    const allFileUploads = [];

    const song = {
        id: details.id,
        organizationID: orgID,
        name: details.name?.trim(),
        artist: details.artist?.trim(),
        defaultKey: details.defaultKey,
        tempo: details.tempo,
        spotifyURL: details.spotifyURL,
        appleMusicURL: details.appleMusicURL,
        amazonMusicURL: details.amazonMusicURL,
        youtubeMusicURL: details.youtubeMusicURL,
        createdByID: !details.id ? createdByID : undefined
    }

    if(!details.id){
        const newFolder = await saveFolder({name:details.name, createdByID:createdByID, noMessage: true})
        song.folderID = newFolder.id;
    }
    else{
        song.folderID = details.folderID
    }

    const folderPath = `${orgID}/music/${song.folderID}`;
    const allFilesToAdd = [];

    details.chordFile && allFilesToAdd.push(details.chordFile);
    details.lyricFile && allFilesToAdd.push(details.lyricFile);
    details.selfHostedTrackFile && allFilesToAdd.push(details.selfHostedTrackFile);
    (details.files && details.files.length > 0) && allFilesToAdd.push(...details.files);

    const newFiles = await saveFiles({
        files: allFilesToAdd, 
        path: folderPath + "/", 
        folderID: song.folderID, 
        uploadedByID: createdByID, 
        orgID: orgID
    });

    let nextIndex = 0;


    if(!details.chordFileID && details.chordFile && details.chordFile.uri){
        await saveFile(details.chordFile.uri, `${folderPath}/${details.chordFile.name.trim()}`);
        song.chordFileID = newFiles[nextIndex].id
        nextIndex++;
    }
    else if(details.chordFileID && !details.chordFile){
        song.chordFileID = null
    }


    if(details.lyricFile && details.lyricFile.uri){
        await saveFile(details.lyricFile.uri, `${folderPath}/${details.lyricFile.name.trim()}`);
        song.lyricFileID = newFiles[nextIndex].id
        nextIndex++;
    }
    else if(details.lyricFileID && !details.lyricFile){
        song.lyricFileID = null
    }


    if(details.selfHostedTrackFile && details.selfHostedTrackFile.uri){
        await saveFile(details.selfHostedTrackFile.uri, `${folderPath}/${details.selfHostedTrackFile.name.trim()}`);
        song.selfHostedTrackFileID = newFiles[nextIndex].id
        nextIndex++;
    }
    else if(details.selfHostedTrackFileID && !details.selfHostedTrackFile){
        song.selfHostedTrackFileID = null
    }


    if(details.files && details.files.length > 0){
        details.files.forEach(async file => {
            if(file.uri){
                await saveFile(file.uri, `${folderPath}/${file.name.trim()}`);   
            }
        })
    }

    Promise.all(allFileUploads).then(responses => {
        
    })
    .catch(async e => {
        ErrorHandler(e);
        Toast.show({
            type: 'error',
            text2: `Error saving files: ${e}`
        });
    })


    const {error, data} = await supabase.from('Songs').upsert(song, {onConflict: 'id'});

    if(error){
        ErrorHandler(Error(error.message), {song}, `Something went wrong saving song`)
        return [];
    }

    return data;
}


const archiveSong = async ({id, isArchived}) => {
    const {error, data} = await supabase.from('Songs').update({isArchived}).eq('id', id);

    if(error){
        ErrorHandler(Error(error.message), {id}, `Something went wrong archiving that song`)
        return [];
    }

    return data;
}


const deleteSong = async (id) => {
    const {error, data} = await supabase.from('Songs').delete().eq('id', id);

    if(error){
        ErrorHandler(Error(error.message), {id}, `Something went wrong deleting that song`)
        return [];
    }

    return data;
}

export { 
    getSongs,
    getSong,
    getSongsByEventInstance,
    saveSong,
    deleteSong,
    archiveSong
}